export default {
  BUTTON_PRIMARY_CLASS: 'button btn btn-primary',
  BUTTON_SECONDARY_CLASS: 'button btn btn-primary',
  LOAD_MORE_BUTTON_CLASS: 'btn cm_btn',

  PRODUCT_REPEATER_CLASS: 'product-items columns-3',

  SEARCH_BOX_INPUT_CLASS: 'search-text hasPlaceholder',

  MIN_PRICE: 'Min',
  MAX_PRICE: 'Max',

  TOTAL_HITS: 'Search Results',
  FACET_TITLE_ICON: '<span class="facetselectedsize" rt-if="this.selectedSize > 0">({{selectedSize}})</span>',
  CURRENT_SEARCH: 'Your search:',
  LOAD_MORE_TEXT: 'LOAD MORE',
};
